import React from "react";

import { Layout } from "antd";
const { Content } = Layout;

import "./style.scss";
const styleWrapperClass = "basepage";

function BasePage(props) {
  return (
    <div className={styleWrapperClass}>
      <Layout>
        <Content>{props.children}</Content>
      </Layout>
    </div>
  );
}

export default BasePage;
